import styled from 'styled-components'
import { backgroundOrange } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { panelSurface } from '@components/Card'

export const BalancesPageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	background-color: ${backgroundOrange};
	height: 100%;
`


export const ContentContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	padding: 24px;

	${media.phone} {
		padding: 16px 14px;
	}
`

export const SplitLayout = styled.div`
	display: flex;
	gap: 24px;
	flex: 1;
	min-height: 0;

	${media.tabletWide} {
		display: none;
	}
`

export const MembersColumn = styled.section`
	${panelSurface}
	flex: 0 0 380px;
	min-width: 0;
	display: flex;
	flex-direction: column;
	padding: 16px 16px 16px 20px;
`

export const ActivityColumn = styled.section`
	${panelSurface}
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	padding: 16px 16px 16px 20px;
`

export const MobileLayout = styled.div`
	display: none;
	flex: 1;
	min-height: 0;
	flex-direction: column;

	${media.tabletWide} {
		display: flex;
	}
`

export const MobilePanel = styled.div<{ $active: boolean }>`
	${panelSurface}
	display: ${({ $active }) => ($active ? 'flex' : 'none')};
	flex-direction: column;
	flex: 1;
	min-height: 0;
	padding: 16px 16px 16px 20px;
`

